export default __webpack_public_path__ + "static/media/coverofdusk.e0f03dbe.png";